import React, { FC, PropsWithChildren } from 'react';
import LoggedInHeader from '../Header/LoggedInHeader';
import LoggedOutHeader from '../Header/LoggedOutHeader';
import Navbar from '../Navbar/Navbar';
import { NavbarProvider } from '../../../hooks/useNavbar';
import { CategoryPreview, ArticlePreview, User, Author } from '../../../../shared/types';

import './index.scss';

interface LayoutProps {
  categories: CategoryPreview[];
  topArticles: ArticlePreview[];
  user: User;
  author?: Author;
}

const Layout: FC<PropsWithChildren<LayoutProps>> = (props) => {
  const { categories, topArticles, children, user, author } = props;

  return (
    <NavbarProvider>
      <div className="fiverr-guides content-hub">
        {user ? <LoggedInHeader user={user} /> : <LoggedOutHeader />}
        <div className="max-width-container">
          <Navbar categories={categories} topArticles={topArticles} author={author} />
          <div className="content-body">{children}</div>
        </div>
      </div>
    </NavbarProvider>
  );
};

export default Layout;
